var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetTypeZip = function SvgAssetTypeZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.5h1v2H18a.5.5 0 0 1 0 1h-1.5v2H18a.5.5 0 0 1 0 1h-1.5v1a.5.5 0 0 1-1 0v-1H14a.5.5 0 0 1 0-1h1.5v-2H14a.5.5 0 0 1 0-1h1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 6v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-1.707-1.707A1 1 0 0 0 9.586 4H4a2 2 0 0 0-2 2m9.586 1-2-2H4a1 1 0 0 0-1 1v2.5h18V8a1 1 0 0 0-1-1zM21 18V9.5H3V18a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgAssetTypeZip;